export type QueryResult<T> = { data: T | null; error: unknown };

export type SupabaseDataProvider = {
  from(table: string): {
    select(columns: string): {
      eq(
        column: string,
        value: string,
      ): {
        order(column: string): Promise<QueryResult<Record<string, unknown>[]>>;
      };
      order(column: string): Promise<QueryResult<Record<string, unknown>[]>>;
    };
  };
  rpc(
    functionName: string,
    parameters: Record<string, unknown>,
  ): Promise<QueryResult<Record<string, unknown>[]>>;
};

export function requireRows(result: QueryResult<Record<string, unknown>[]>) {
  if (result.error || !result.data) throw new Error('REQUEST_FAILED');
  return result.data;
}

export function requireFirstRow(
  result: QueryResult<Record<string, unknown>[]>,
) {
  const row = requireRows(result)[0];
  if (!row) throw new Error('INVALID_RESPONSE');
  return row;
}
